<template>
  <div class="login-wrap">
    <div class="login-form">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm login-container">
        <!-- <h3 class="title"><img src="../assets/img/loginlogo.jpg" style="max-width: 100%" alt=""></h3> -->
        <h3 class="title"><img src="../assets/img/loginlogo.jpg" style="max-width: 100%" alt="">
          <div style="text-align: left;font-size: 30px">禾略运营指标系统</div>
        </h3>
        <el-form-item prop="username" style="margin-bottom:40px">
          <el-input type="text" v-model="ruleForm.username" prefix-icon='el-icon-zhanghu' auto-complete="off" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item prop="password" style="margin-bottom:40px">
          <el-input type="password" v-model="ruleForm.password" prefix-icon='el-icon-mima' auto-complete="off"  @keyup.enter.native="submitForm('ruleForm')" placeholder="请输入密码"></el-input>
        </el-form-item>

        <el-form-item style="width:100%;">
          <el-button class="btn-add" type="primary" style="width:100%;height: 60px;background-color: #347ae2;box-shadow: 0px 5px 16px 0px rgba(52, 122, 226, 0.47);border-radius: 6px;" @click="submitForm('ruleForm')" :loading="logining">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="login-img">
      <!-- <div class="logo_left">
        <div class="logo-img"></div>
      </div>
      <div class="logo_bottom">
        <div class="logo-img1"></div>
      </div> -->
    </div>
  </div>

</template>
<script type="text/ecmascript-6">
import { login } from '../api/userMG'
import { setCookie, getCookie, delCookie } from '../utils/util'
import md5 from 'js-md5'

export default {
  name: 'login',
  data() {
    return {
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //username和password默认为空
        username: '',
        password: '',
      },
      //rules前端验证
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取存在本地的用户名密码
    // this.getuserpwd()
  },
  // 里面的函数只有调用才会执行
  methods: {
    // // 获取用户名密码
    // getuserpwd() {
    //   if (getCookie('user') != '' && getCookie('pwd') != '') {
    //     this.ruleForm.username = getCookie('user')
    //     this.ruleForm.password = getCookie('pwd')
    //     this.rememberpwd = true
    //   }
    // },
    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true
          // 测试通道，不为空直接登录
          // 注释

          // this.$axios.post('/api/login', qs.stringify(this.ruleForm),).then(res=>{
          //   console.log(res)
          //   const sessionId = decodeURI(res.headers['set-cookie'].split(';')[1].split('=')[1])
          //   console.log(sessionId)
          // })
          login(this.ruleForm).then(res => {
            if (res.code===200) {
              this.$message.success(res.msg)

              // if (this.rememberpwd) {
              //   //保存帐号到cookie，有效期7天
              //   setCookie('user', this.ruleForm.username, 7)
              //   //保存密码到cookie，有效期7天
              //   setCookie('pwd', this.ruleForm.password, 7)
              // } else {
              //   delCookie('user')
              //   delCookie('pwd')
              // }
              //如果请求成功就让他2秒跳转路由
              setTimeout(() => {
                this.logining = false
                // 缓存用户个人信息
                localStorage.setItem('userdata', this.ruleForm.username)
                localStorage.setItem('token', res.token)
                this.$store.commit('login', 'true')
                this.$router.push({ path: '/share/current' })
              }, 1000)
            } else {
              this.$message.error(res.msg)
              this.logining = false
              return false
            }
          })
        } else {
          this.$message.error('请输入用户名密码！')
          this.logining = false
          return false
        }
      })
    },
  }
}
</script>

<style scoped>
.login-wrap {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* background-color: #112346; */
  background-repeat: no-repeat;
  background-position: center right;
  background-size: cover;
  /* overflow-y: hidden; */
}

.login-img{
  width: 60%;
  height: 100%;
  background-image: url("../assets/img/bg.jpg");
  background-repeat: no-repeat;
  /* background-position: center right; */
  background-size: cover;
}
.logo_left{
  position: relative;
  top: 5%;
  left: 5%;
  width: 100%;
  height: 10%;
}
.logo-img{
  width: 25%;
  height: 100px;
  /* background-image: url("../assets/img/bg-log2.png"); */
  background-repeat: no-repeat;
  background-size: 100%;
}
.logo-img1{
  width: 40%;
  height:200px;
  /* background-image: url("../assets/img/bg-log1.png"); */
  background-repeat: no-repeat;
  background-size: 100%;
}
.logo_bottom{
  position: relative;
  top: 60%;
  left: 10%;
}
.login-form{
  width: 40%;
  height: 100%;
  display: flex;
  align-items: center;
}
.login-container {
  border-radius: 5px;
  width: 50%;
  margin: 0 auto;
  padding: 80px 25px;
  text-align: left;
}
.title {
  margin: 0px auto 80px auto;
  text-align: center;
  color: #505458;
}
/* .login-container >>> .el-form-item{
  margin-bottom: 45px;
} */
.login-container>>>.el-input__inner {
  border-radius: 2px;
  border: solid 1px #e6effb;
}
.login-container>>>.el-input__inner:focus {
  color: #57607c;
  border-radius: 2px;
  border: solid 1px #293f7c
}

</style>




// WEBPACK FOOTER //
// src/views/login.vue